var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVuesaxBoldRulerPen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.47 2c-1.66 0-3 1.59-3 3.25h5c.41 0 .75.34.75.75s-.34.75-.75.75h-4.5a.5.5 0 0 0-.5.5v1.5a.5.5 0 0 0 .5.5h2.31c.41 0 .75.34.75.75s-.34.75-.75.75h-2.31a.5.5 0 0 0-.5.5v1.455a.5.5 0 0 0 .496.5l4.505.045c.42 0 .75.34.75.76-.01.41-.34.74-.75.74h-.01l-4.485-.045a.5.5 0 0 0-.505.5v1.545a.5.5 0 0 0 .5.5h3.4a.749.749 0 1 1 0 1.5h-3.132a.5.5 0 0 0-.45.716c.81 1.69 1.705 2.534 2.682 2.534h4c1.65 0 3-1.34 3-3V5c0-1.66-1.35-3-3-3h-4zM7.94 6.25H3.03a.5.5 0 0 1-.5-.5v-.8C2.53 3.33 3.86 2 5.49 2c1.62 0 2.95 1.33 2.95 2.95v.8a.5.5 0 0 1-.5.5zM2.96 19.43l.81 1.36c.95 1.58 2.49 1.58 3.43 0l.82-1.36c.23-.38.42-1.07.42-1.52V8.25a.5.5 0 0 0-.5-.5H3.03a.5.5 0 0 0-.5.5v9.66c0 .45.19 1.14.43 1.52z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldRulerPen);
export default __webpack_public_path__ + "static/media/vuesax-bold-ruler-pen.e90bd77058c0b975e7475818826be9e2.svg";
export { ForwardRef as ReactComponent };